import { Redirect, Route, useHistory } from "react-router-dom";
import { checkLocalStorageTokens } from "../../utils/AuthFunctions";

interface RxPrivateRouteProps {
	path: string;
	children: JSX.Element;
	redirectPath?: string;
	scopes?: string[];
	exact?: boolean;
}

const RxPrivateRoute = (props: RxPrivateRouteProps) => {
	const history = useHistory();

	const redirectLoginPath =
		"/login" +
		(props.path === "/login" ? "" : "?redirect=" + history.location.pathname);

	return (
		<Route exact={props.exact} path={props.path}>
			{checkLocalStorageTokens() === (props.redirectPath !== undefined) ? (
				<Redirect
					to={{
						pathname:
							props.redirectPath !== undefined
								? props.redirectPath
								: redirectLoginPath,
					}}
				/>
			) : (
				props.children
			)}
		</Route>
	);
};

export default RxPrivateRoute;
